<template>
  <div class="num_pad">
    <button @click="$emit('changeCount', 'decrease')">
      <img src="@/assets/down-icon.png" />
    </button>
    <div class="display_num">{{ num }} {{ unit }}</div>
    <button @click="$emit('changeCount', 'increase')">
      <img src="@/assets/up-icon.png" />
    </button>
  </div>
</template>
<script>
export default {
  name: 'num-check',
  props: {
    num: Number,
    unit: String
  }
}
</script>
<style scoped lang="scss">
@import "@/assets/base.scss";

.num_pad {
  display: flex;
  justify-content: space-between;
  height: 7.125vh;

  .display_num {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 29.84375vw;
    height: 7.125vh;
    background: $white;
    font-size: 30px; // IE11 fallback
    font-size: unquote("min(2.34375vw, 30px)");
    border-radius: 0.375vh;
  }

  button {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 4.21875vw;
    height: 7.125vh;
    background: $white;
    border: 0;
    border-radius: 0.375vh;
  }
}
</style>
